import * as React from "react";

function WifiOk(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 22 15.55" width="1em" height="1em" {...props}>
      <defs>
        <style>{".prefix__cls-2{fill:#fff}"}</style>
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_2-2" data-name="Layer 2">
          <path
            d="M0 4.55l2 2a12.73 12.73 0 0118 0l2-2a15.57 15.57 0 00-22 0z"
            fill="#b3b3b3"
          />
          <path
            className="prefix__cls-2"
            d="M8 12.55l3 3 3-3a4.24 4.24 0 00-6 0zM4 8.55l2 2a7.07 7.07 0 0110 0l2-2a9.91 9.91 0 00-14 0z"
          />
        </g>
      </g>
    </svg>
  );
}

const MemoWifiOk = React.memo(WifiOk);
export default MemoWifiOk;
